
import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./Dashboard.module.scss";

import { useParams } from "react-router-dom";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { getQueryVariable } from "../../utils/getQueryParam";
import TeamDashboard from "./TeamDashboard";

export function DashboardID(props) {
  const { id } = useParams();
  const userFullName = getQueryVariable("name");
  useDocumentTitle(props.title);
  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle
              style={{ display: "flex", justifyContent: "flex-start" }}
              hasBackButton
            >
              {userFullName}'s Scoresheet
            </SectionTitle>

            <TeamDashboard userId={id} />
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
